import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { OrganizationVm, CreateOrganizationDto, UpdateOrganizationDto } from '../models';

@Injectable({ providedIn: 'root' })
export class OrganizationService {
  private http = inject(HttpClient);
  private base(tenantId: string) { return `${environment.apiBaseUrl}/tenants/${tenantId}/organizations`; }

  list(tenantId: string): Observable<OrganizationVm[]> {
    return this.http.get<OrganizationVm[]>(this.base(tenantId));
  }

  create(tenantId: string, dto: CreateOrganizationDto): Observable<OrganizationVm> {
    return this.http.post<OrganizationVm>(this.base(tenantId), dto);
  }

  update(tenantId: string, organizationId: string, dto: UpdateOrganizationDto): Observable<OrganizationVm> {
    return this.http.put<OrganizationVm>(`${this.base(tenantId)}/${organizationId}`, dto);
  }

  remove(tenantId: string, organizationId: string): Observable<void> {
    return this.http.delete<void>(`${this.base(tenantId)}/${organizationId}`);
  }
}
